<h1 class="mb-4">
  <mdb-icon fas icon="cog"></mdb-icon> Productos General
</h1>
<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Productos</span>
      <span> /</span>
      <span>Productos General</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">

      <div class="row filtros-body">
        <div class="col" style="max-width: 240px;">
          <!-- Material checked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaResumen" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_RESUMEN" />
            <label class="form-check-label" for="rbVistaResumen">Vista Resumen</label>
          </div>
          <!-- Material unchecked -->
          <div class="form-check">
            <input type="radio" class="form-check-input" id="rbVistaDetalle" mdbInput formControlName="tipoVista"
              [value]="RB_TIPO_VISTA_DETALLE" />
            <label class="form-check-label" for="rbVistaDetalle">Vista Detallada</label>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" required
              formControlName="fechaDesde"></mdb-date-picker>
            <div *ngIf="
                    formHeader.get('fechaDesde').invalid &&
                    (formHeader.get('fechaDesde').dirty ||
                    formHeader.get('fechaDesde').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('fechaDesde').hasError('required')">Ingrese fecha desde
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 200px">
          <div class="md-form mb-0">
            <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" required
              formControlName="fechaHasta"></mdb-date-picker>
            <div *ngIf="
                    formHeader.get('fechaHasta').invalid &&
                    (formHeader.get('fechaHasta').dirty ||
                    formHeader.get('fechaHasta').touched)
                  ">
              <mdb-error *ngIf="formHeader.get('fechaHasta').hasError('required')">Ingrese fecha hasta
              </mdb-error>
            </div>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsRubro" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="rubros"></mdb-select>
            <label>Rubro de Productos</label>
          </div>
        </div>
        <div class="col" style="max-width: 300px">
          <div class="md-form">
            <mdb-select [options]="optionsFamilia" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Todos" formControlName="familias"></mdb-select>
            <label>Familia de Productos</label>
          </div>
        </div>
        <div *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
          <div class="col" style="width: 270px">
            <div class="md-form">
              <mdb-select [options]="optionsVendedor" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
                placeholder="Todos" formControlName="vendedores"></mdb-select>
              <label>Vendedor</label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6">
      <div></div>
      <!-- <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="resumenBuscar(1)"
        *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="detalleBuscar(1)"
        *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button> -->
      <button *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN" mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="resumenBuscarNotificacion()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
      <button *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE" mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="detalleBuscarNotificacion()">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<!-- Listado -->
<div class="card mb-2 wow">
  <div class="card-body p-1 justify-content-between">
    <div *ngIf="resumen_loading || detalle_loading" class="w-100 d-block text-center">
      <mdb-spinner *ngIf="resumen_loading || detalle_loading" spinnerColor="blue"></mdb-spinner>
    </div>
    <div
      *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0 && formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN"
      #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
      <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
        <span aria-hidden="true">&times;</span>
      </button>
      <strong>Se ha enviado la solicitud!</strong> En breve minutos llegara la notificacion para descagar el reporte.
    </div>
    <div class="table-responsive" *ngIf="!resumen_loading && formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length !== 0">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="!resumen_loading && resumen_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Descripción</th>
            <!-- <th scope="col">UMP</th>
            <th scope="col">UMS</th> -->
            <!-- <th scope="col" class="text-center">Cantidad</th> -->
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col">Caja</th>
            <th scope="col">Fraccion</th>
            <th scope="col" class="text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="100%" style="text-align: center"
              *ngIf="!resumen_loading && resumen_listaMovimientos?.length === 0">
              No se encontró información
            </td>
          </tr>
          <tr *ngFor="let mov of resumen_listaMovimientos">
            <td>{{ mov.sku }}</td>
            <td>{{ mov.descripcion }}</td>
            <!-- <td>???</td>
            <td>???</td> -->
            <!-- <td class="text-center">{{mov.cantidad | numerico}}</td> -->
            <td>{{ mov.rubro_nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td>{{calcularStockFormatoPrincipal(mov.listaStockxUnidades)}}</td>
            <td>{{calcularStockFormatoSecundario(mov.listaStockxUnidades)}}</td>
            <td class="text-right">{{ mov.precio_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="6"><strong>Totales</strong></td>
            <td class="text-right">$ {{ resumen_totales.monto_neto | numerico }}</td>
            <td class="text-right">$ {{ resumen_totales.descuento | numerico }}</td>
            <td class="text-right">$ {{ resumen_totales.neto_total | numerico }}</td>
          </tr>
        </tbody>
        <app-pagination [context]="resumen_paginationContext" (onPageChange)="resumenOnPageChange($event)"
          *ngIf="resumen_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
    <div
    *ngIf="!detalle_loading && detalle_listaMovimientos?.length === 0 && formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE"
    #alert class="alert alert-info alert-dismissible fade show m-0" role="alert">
    <button type="button" class="close" aria-label="Close" (click)="closeAlert()">
      <span aria-hidden="true">&times;</span>
    </button>
    <strong>Se ha enviado la solicitud!</strong> En breve minutos llegara la notificacion para descagar el reporte.
  </div>
    <div class="table-responsive" *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length !== 0">
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="detalle_listaMovimientos">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Descripción</th>
            <th scope="col">Rubro</th>
            <th scope="col">Familia</th>
            <th scope="col">Vendedor</th>
            <th scope="col">Caja</th>
            <th scope="col">Fraccion</th>
            <th scope="col" class="doble-linea text-right">Monto Neto</th>
            <th scope="col" class="text-right">Descuento</th>
            <th scope="col" class="doble-linea text-right">Total Neto</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let mov of detalle_listaMovimientos">
            <td>{{ mov.sku }}</td>
            <td>{{ mov.descripcion }}</td>
            <td>{{ mov.rubro_nombre }}</td>
            <td>{{ mov.familia_nombre }}</td>
            <td>{{ mov.vendedor_nombre }}</td>
            <td>{{calcularStockFormatoPrincipal(mov.listaStockxUnidades)}}</td>
            <td>{{calcularStockFormatoSecundario(mov.listaStockxUnidades)}}</td>
            <td class="text-right">{{ mov.precio_neto | numerico }}</td>
            <td class="text-right">{{ mov.descuento | numerico }}</td>
            <td class="text-right">{{ mov.monto_neto | numerico }}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5">
          <tr>
            <td class="text-right" colspan="7"><strong>Totales</strong></td>
            <td class="text-right">$ {{detalle_totales.monto_neto | numerico}}</td>
            <td class="text-right">$ {{detalle_totales.descuento | numerico}}</td>
            <td class="text-right">$ {{detalle_totales.neto_total | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="detalle_paginationContext" (onPageChange)="detalleOnPageChange($event)"
          *ngIf="detalle_listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_RESUMEN && resumen_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="resumenDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
<div class="card mb-2 wow"
  *ngIf="formHeader.get('tipoVista').value === RB_TIPO_VISTA_DETALLE && detalle_listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button size="sm" mdbBtn type="button" color="success" mdbWavesEffect class="btn btn-sm"
      (click)="detalleDownloadExcelPdf('XLS')">
      Excel
    </button>
  </div>
</div>
